import Script from 'next/script'

import { env } from '@/shared/config'

import { scriptLoaded } from './model'

export function GoogleGSIClientScript() {
    if (!env.OAUTH_GOOGLE_CLIENT_ID) {
        return null
    }

    return (
        <Script
            //  NOTE: This is a workaround to ensure that CookieYes does not block the Google GSI script.
            //  https://www.cookieyes.com/documentation/implement-prior-consent-using-cookieyes/
            data-cookieyes="cookieyes-functional"
            src="https://accounts.google.com/gsi/client"
            strategy="afterInteractive"
            onLoad={scriptLoaded}
        />
    )
}
